<app-tabla
  [totalCount]="totalCount"
  [datos]="estadoEntidads"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [showHijos]="false"
  [emptyState]="{ title: 'Todavía no hay estados de entidades' }"
></app-tabla>
